import { Component, OnInit, ViewChild, ElementRef, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { SelectItem } from 'lib/common';
import { SearchCriteriaComponent } from './search-criteria/search-criteria.component';
//import { setTimeout } from 'timers';

import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { startWith, map, filter } from 'rxjs/operators';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material';
import { CommonFilterService } from 'src/app/shared/services/common-filter/common-filter.service';

@Component({
  selector: 'app-filters-tabs',
  templateUrl: './filters-tabs.component.html',
  styleUrls: ['./filters-tabs.component.scss', '../filters-tabs/search-criteria/search-criteria.component.scss', '../styles/select-list.css'],
})
export class FiltersTabsComponent implements OnInit, AfterViewInit {
  //https://tutorialsforangular.com/2020/11/20/accessing-a-child-components-methods-from-a-parent-component/
  //https://medium.com/@sohailnazar4/angular-calling-parent-component-function-from-child-component-5dcccdc771d9
  @ViewChild(SearchCriteriaComponent, { static: true }) child: SearchCriteriaComponent;

  filters: SelectItem[] = [];
  filtersObservable: SelectItem[];
  selectedFilters: number[] = [];

  modelFilter: string = "";
  editingFilter: boolean = true;
  critErrorsFilter: boolean = false;

  @ViewChild(MatAutocompleteTrigger, { static: false }) autocompleteTrigger: MatAutocompleteTrigger;
  @ViewChild('input', { static: false }) inputCtrl;

  //https://www.concretepage.com/angular/angular-formcontrol-setvalue
  control = new FormControl();

  @Input() myFilterName = "null";

  toHighlight: string = '';
  //myControl = new FormControl();
  //options: string[] = ['One', 'Two', 'Three'];
  //filteredOptions: string[];

  constructor(private cd: ChangeDetectorRef, private commonFilterService: CommonFilterService) { }

  init = false;
  ngOnInit() {
    this.init = true;
    if (this.myFilterName == "")
      this.myFilterName = "null";
  }

  isLoading = false;
  interval;
  ngAfterViewInit() {
    this.onFilterChange(null, false);

    //this.myControl.valueChanges.subscribe(newValue => {
    //  this.filteredOptions = this.filterValues(newValue);
    //})

    //https://stackoverflow.com/questions/48337188/angular-material-autocomplete-not-working-no-errors-shown
    //https://www.positronx.io/angular-8-autocomplete-tutorial-with-angular-material/
    this.control.valueChanges.subscribe(newValue => {
      this.filtersObservable = this._filter(newValue);
    })

    if (this.myFilterName != "null") {
      this.isLoading = true;
      //setTimeout(() => {
      //  const selMatOption = this.autocompleteTrigger.autocomplete.options.toArray().find((o) => o.value.name === this.myFilterName);
      //  this.control.setValue(selMatOption.value);
      //}, 5000);
      this.interval = setInterval(() => {
        //console.log(this.AutoRefreshInfo.AutoRefStop);
        //https://stackoverflow.com/questions/54686626/set-value-of-angular-material-select-autocomplete-programmatically
        const selMatOption = this.autocompleteTrigger.autocomplete.options.toArray();
        if (selMatOption.length > 0) {
          //https://stackoverflow.com/questions/63344796/how-to-trigger-optionselected-angular-material-autocomplete-programmatically
          this.control.setValue(selMatOption.find((o) => o.value.name === this.myFilterName).value);
          clearInterval(this.interval);
        }
      }, 1000);
      this.isLoading = false;
    }
    else
      this.isLoading = false;
  }
  //filterValues(search: string) {
  //  return this.options.filter(value =>
  //    value.toLowerCase().indexOf(search.toLowerCase()) === 0);
  //}

  displayFn(selectItem: SelectItem): string {
    return selectItem && selectItem.name && !selectItem.name.includes('--Create New--') ? selectItem.name : '';
  }

  _filter(value: any): SelectItem[] {
    let filterValue = '';
    this.toHighlight = '';
    if (typeof value === "string") {
      this.toHighlight = value;
      filterValue = value.toLowerCase();
    }
    else {
      this.toHighlight = value.name;
      filterValue = value.name.toLowerCase();
    }
    return this.filters.filter(option => option.name.toLowerCase().includes(filterValue) || option.name.includes('--Create New--'));
  }

  async onFilterChange(event, emittedOrNot: boolean) {

    ///////  the  record that was renamed and saving as new record and immediately deleting the newly created record.it should clear all control and set to default
    if (event == null)
      this.FilterClose = false;

    if (this.FilterClose) {
      this.FilterClose = false;
      return;
    }
   
    debugger;
    this.isLoading = true;
    if (emittedOrNot || event == undefined || event == null) {//refresh ddl to latest list from db and reset all controls to default and fill ddl with filters
      let filters = await this.child.getFilterConfig(0, '0');
      this.getList(filters);
      if (event !== undefined) {
        if (this.myFilterName == "null")
          this.OpenAutoCompeleteDailog(true);
      }
    }

    if (event !== undefined && event !== null) {//selected filter loads resp. criteria into controls and display saved tables
      let selID = parseInt(event);
      let filter = this.filters.find(x => x.id == selID);
      await this.child.getFilterConfig(1, event);
      this.modelFilter = filter.name;
      this.inputLength = this.modelFilter.length;
      this.selectedFilters = [selID];

      this.isLoading = false;
    }
    else if (event == null) {
      this.selectedFilters = [];
      this.modelFilter = "";
      this.inputLength = 0;
      this.deleteFilter();
      this.isLoading = false;
    }
  }

  getList($event) {
    this.filters = $event;
    //console.log(this.filters)
    this.filtersObservable = $event;

    if (this.myFilterName != "null" && this.init)
      this.setFilterByName(this.myFilterName);
  }

  resetFilterOnEmptyInput() {
    console.log('sf')
    
  }
  setFilter(event) {
    this.modelFilter = event.option.value.name;
    this.inputLength = this.modelFilter.trim().length;
    this.child.resetMsg();
    //console.log(this.modelFilter)
    let filterName = this.modelFilter.trim();
    this.resetCritErrors();
    if (filterName.length == 0) {
      this.onFilterChange(null, false);
      return;
    }
    let found = this.filters.find(x => x.name == filterName);
    if (found)
      this.onFilterChange(found.id, false);
  }
  setFilterByName(name) {
    this.modelFilter = name;
    this.child.resetMsg();
    //console.log(this.modelFilter)
    let filterName = this.modelFilter.trim();
    this.resetCritErrors();
    if (filterName.length == 0) {
      this.onFilterChange(null, false);
      return;
    }
    let found = this.filters.find(x => x.name == filterName);
    //console.log(found)
    if (found)
      this.onFilterChange(found.id, false);

    this.init = false;
  }
  saveFilter(item) {
    debugger;
    this.critErrorsFilter = false;
    if (typeof this.control.value === "string")
      this.modelFilter = this.control.value;
    else
      this.modelFilter = this.control.value.name;
    this.inputLength = this.modelFilter.trim().length;

    let filterName = this.modelFilter.trim();
    //console.log(this.modelFilter)
    if (filterName.length === 0) {
      this.critErrorsFilter = true;
      this.critErrorDesc = "*Required";
      return false;
    }
    else if (filterName.length > 50) {
      this.critErrorsFilter = true;
      this.critErrorDesc = "*Max 50 characters only";
      return false;
    }

    if (this.selectedFilters.length > 0) {//Update

      let currFilterItem = this.filters.find(x => x.id == this.selectedFilters[0]);
      if (currFilterItem) {//item selected from ddl
        if (filterName == currFilterItem.name) {//input and ddl selection are same
          item.ID = currFilterItem.id;
          this.child.updateFilterConfig(item);
          if (this.myFilterName == filterName)
            this.commonFilterService.basicFilterSavedRefresh();//lets filters comp know that loaded filter updated
        }
        else {//Add as new duplicate using selected ddl
          item.CriteriaName = filterName;
          this.child.insertFilterConfig(item);
        }
      }
      else {//Add new
        let currFilterItemIndex = this.filters.findIndex(x => x.name == filterName);
        if (currFilterItemIndex == -1) {
          item.CriteriaName = filterName;
          this.child.insertFilterConfig(item);
        }
        else {
          this.critErrorsFilter = true;
          this.critErrorDesc = "*Filter name already exists!";
          return false;
        }
      }
    }
    else {//Add new
      let currFilterItemIndex = this.filters.findIndex(x => x.name == filterName);
      if (currFilterItemIndex == -1) {
        item.CriteriaName = filterName;
        this.child.insertFilterConfig(item);
      }
      else {
        this.critErrorsFilter = true;
        this.critErrorDesc = "*Filter name already exists!";
        return false;
      }
    }
  }

  deleteFilter() {
    //this.control = new FormControl();
    this.control.setValue("");
 }

  critErrors: boolean = false;
  critErrorDesc = "*Required";

  resetCritErrors() {
    this.critErrorsFilter = false;
    this.critErrors = false;
  }

  inputLength = 0;
  setLimitedOptions = true;
  onKeydownMain($event) {
    if (!this.setLimitedOptions) {
      this.setLimitedOptions = true;
      this.control.valueChanges.subscribe(newValue => {
        this.filtersObservable = this._filter(newValue);
      })
    }

    this.inputLength = $event.target.value.length;
    this.modelFilter = $event.target.value;
    if (this.inputLength == 0) {
      this.control.setValue("");
      let firstSelectedOption = this.autocompleteTrigger.autocomplete.options.find(o => o.value.id == this.selectedFilters[0]);
      if (firstSelectedOption) {
        this.FilterClose = true;
        this.control.setValue("");
        firstSelectedOption.deselect();
      }
    }
  }
  clearInputText() {
    this.control.setValue("");
    this.inputLength = 0;
  }
  clearInput(input: HTMLInputElement, auto: MatAutocomplete) {
    this.control.setValue("");
    this.selectedFilters = [];
    this.modelFilter = "";
    this.inputLength = 0;
    input.focus();
    //input.placeholder = '';
    //input.value = '';
    //auto.options.forEach(option => option.deselect());
    //auto.closePanel();
    this.child.getFilterConfig(0, '0');
    setTimeout(() => this.autocompleteTrigger.openPanel());    
  }

  openOrClose = false;
  FilterClose = false;
  OpenAutoCompeleteDailog(init?, closed?) {
    let tmOut = 0;
    if (init)
      tmOut = 1000;
    else {
      this.setLimitedOptions = false;
      this.filtersObservable = this.filters;
    }

    //setTimeout(() => { this.autocompleteTrigger.openPanel() }, tmOut);
    //console.log(this.inputCtrl)
    if (this.openOrClose == true || closed) {
      setTimeout(() => this.autocompleteTrigger.closePanel());
      this.openOrClose = false;
    }
    else {
      setTimeout(() => {
        this.inputCtrl.nativeElement.blur();
        this.inputCtrl.nativeElement.focus();
        this.toHighlight = this.inputCtrl.nativeElement.value;
        if (this.inputLength > 0) {
          let firstSelectedOption = this.autocompleteTrigger.autocomplete.options.find(o => o.selected);
          if (firstSelectedOption === undefined && this.selectedFilters.length > 0) {
            firstSelectedOption = this.autocompleteTrigger.autocomplete.options.find(o => o.value.id == this.selectedFilters[0]);
            if (firstSelectedOption) {
              if (this.initArrow)
                this.FilterClose = true;
              firstSelectedOption.select();
              setTimeout(() => {
                this.autocompleteTrigger.openPanel();
                firstSelectedOption._getHostElement().scrollIntoView({
                  block: 'center',
                });
              });
            }
          }
          if (firstSelectedOption) {
            firstSelectedOption._getHostElement().scrollIntoView({
              block: 'center',
            });
          }
        }
        //this.autocompleteTrigger.openPanel();
      }, tmOut);
      this.openOrClose = true;
    }
  }

  initArrow = true;
  SetArrowClick() {
    if (this.initArrow) {
      this.initArrow = false;
    }
  }


}
